import React, { useState, useEffect } from 'react';
import { FormControl, Select as MaterialSelect, Grid, InputLabel, Button, MenuItem, Autocomplete, Popover, Stack, Table, TableBody, TableCell, TableContainer, TextField, TableRow, Typography, Card, CardContent, Tab, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
import { Box } from '@mui/system';
import { DataGrid, GridToolbarQuickFilter, GridToolbarExport, GridEditInputCell, useGridApiContext } from '@mui/x-data-grid';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { CustomButton } from '../../common/custom-button/customButton';
import clsx from 'clsx';
import { ALLOCATE_DEMAND_WORKFLOW, authKey, CALCULATE_MONTHLY_ALLOCATION, DOWNLOAD_DOCUMENT, GENERATE_MONTHLY_ALLOCATION, GENERATE_PO, GET_MONTHLY_ALLOCATION, GET_MONTHLY_ALLOCATION_DASHBOARD, GET_MONTHLY_STAKEHOLDER_ALLOCATION, GET_PAYMENT_DETAILS, GET_PLANNING_NUMBER, GET_USER, GET_USER_BY_ROLES, GET_WORKFLOW_LIST, NOTIFY_STAKEHOLDER, UPLOAD_EXCEL_DCUMENT } from '../../common/URLs';
import { loaderService } from '../../common/custom-loader/loader-service';

import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import Select from 'react-select';
import moment from 'moment/moment';
import { BASIC_DATE_FORMAT, DEMAND_CONSTANTS, DEMAND_ROLES, FILE_NAME_VALIDATION_ERROR, PROD, ROLES } from '../../common/constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { userData } from '../../common/spinLoader';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { MonthlyDashboard } from './MonthlyDashboard';
import { PaymentDetails } from './PaymentDetails';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { debounce } from "lodash";
import { demandAllowedFileTypes } from '../../common/constants';
import { VALIDATION, capitalizeFunction, fileNameValidation, openTextFieldMaxLength } from '../../common/commonValidations';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { CalculateIcon, GenerateIcon, NotificationAlertIcon, ReleaseIcon, SendBackIcon, ViewIcon } from '../../common/icons';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import apiClient from '../../axios';

export const MonthlyAllocation = () => {
    const [arr, setArr] = useState([]);
    const userLoggedIn = userData?.user?.userRoles?.[0].roleName
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [IsAllValuesNotConfirmed, setIsAllValuesNotConfirmed] = useState(false);
    const uuid = localStorage.getItem('uuid');
    const [planningMonth, setPlanningMonth] = useState('Jan');
    const monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const [selectedFinancialYear, setSelectedFinancialYear] = useState();
    const [monthlyAllocationData, setMonthlyAllocationData] = useState([]);
    const [isMonthlyAllocationDisabled, setIsMonthlyAllocationDisabled] = useState(true);
    const [selectedFinancialYearErr, setSelectedFinancialYearErr] = useState('');
    const [planningNumberList, setPlanningNumberList] = useState([]);
    const [selectedPlanningNumber, setSelectedPlanningNumber] = useState('');
    const [open, setOpen] = React.useState(false);

    const [growerMappingList, setGrowerMappingList] = useState([]);
    const [hitMappingList, setHitMappingList] = useState([]);
    const [transporterMappingList, setTransporterMappingList] = useState([]);
    const [lleMappingList, setLleMappingList] = useState([]);
    const [isMappingList, setIsMappingList] = useState([]);

    const [isNotifyStakeholderDisabled, setIsNotifyStakeholderDisabled] = useState(true);
    const [approvalHistoryList, setApprovalHistoryList] = useState([]);
    const [isSendReleaseDisabled, setIsSendReleaseDisabled] = useState(true);
    const [comments, setComments] = useState('');
    const [selectedFile, setSelectedFile] = useState('');
    const [selectedFileName, setSelectedFileName] = useState('');
    const [blobResponse, setBlobResponse] = useState('');
    const [tabValue, setTabValue] = React.useState('1');
    const [paymentListData, setPaymentListData] = useState([]);
    const [monthlyDashboardData, setMonthlyDashboardData] = useState();
    const [pageSize, setPageSize] = React.useState(10);
    const [isPaymentMethodNull, setIsPaymentMethodNull] = React.useState();
    const [processingInchargeUsers, setProcessingInchargeUsers] = React.useState([]);


    const [notifyStakeholderDialog, setNotifyStakeholderDialog] = useState(false);
    const handleNotifyStakeholderDialogOpen = () => setNotifyStakeholderDialog(true);
    const handleNotifyStakeholderDialogClose = () => setNotifyStakeholderDialog(false);
    const [calculateMonthlyAllocationDialog, setCalculateMonthlyAllocationDialog] = useState(false);
    const handleCalculateMonthlyAllocationDialogOpen = () => setCalculateMonthlyAllocationDialog(true);
    const handleCalculateMonthlyAllocationDialogClose = () => setCalculateMonthlyAllocationDialog(false);
    const [sendBackDialog, setSendBackDialog] = useState(false);
    const handleSendBackDialogOpen = () => setSendBackDialog(true);
    const handleSendBackDialogClose = () => setSendBackDialog(false);
    const [actionType, setActionType] = useState();
    const [releaseDialog, setReleaseDialog] = useState(false);
    const handleReleaseOpen = () => setReleaseDialog(true);
    const handleReleaseClose = () => setReleaseDialog(false);
    const [generatePoDialog, setGeneratePoDialog] = useState(false);
    const handleGeneratePoDialogOpen = () => setGeneratePoDialog(true);
    const handleGeneratePoDialogClose = () => setGeneratePoDialog(false);
    const [getStakeholderData, setGetStakeholderData] = useState([]);



    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
    }));

    const columns = [
        {
            field: 'mappingType',
            headerName: 'Route Type',
            width: 200,
            align: 'left',
        },
        {
            field: 'growerUrn',
            headerName: 'Grower',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'growerLandId',
            headerName: 'Grower land ID',
            width: 300,
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'hitUrn',
            headerName: 'HIT',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'lleUrn',
            headerName: 'LLE',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'transporterUrn',
            headerName: 'TR',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'isUrn',
            headerName: 'IS',
            type: 'number',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'tr2',
            headerName: 'TR2',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === null) {
                    return '-';
                }
            }
        },
        {
            field: 'perTonCost',
            headerName: 'Per Ton Cost(in INR)',
            type: 'number',
            width: 180,
            headerAlign: 'center',
        },
        {
            field: 'cbAllocationWithoutMoisture',
            headerName: `CB Qty(without moisture in MT)`,
            headerClassName: 'super-app-theme--header',
            type: 'number',
            width: 260,
        },
        {
            field: 'rbAllocationWithoutMoisture',
            headerName: 'RB Qty(without moisture in MT)',
            renderHeader: (params) => (
                <>
                    <strong>RB Qty</strong><br /><strong>(without Moisture)</strong>
                </>),
            type: 'number',
            headerClassName: 'super-app-theme--header',
            width: 260,
        },
        {
            field: 'cbAllocation',
            headerName: 'CB Qty(in MT)',
            headerClassName: 'super-app-theme--header',
            type: 'number',
            width: 110,

        },
        {
            field: 'rbAllocation',
            headerName: 'RB Qty(in MT)',
            type: 'number',
            width: 110,
            valueFormatter: (params) => {
                if (params.value == 0) {
                    return '-';
                }
            }
        },

        {
            field: 'totalCost',
            headerName: 'Total Cost(in INR)',
            type: 'number',
            width: 110,

        },

    ];
    const approvalHistoryColDef = [
        {
            field: 'ownerName',
            headerName: 'Approver',
            width: 150,

        },
        {
            field: 'createdOn',
            headerName: 'Approval Date',
            valueFormatter: ({ value }) => moment(value).format(BASIC_DATE_FORMAT),
            width: 150,

        },
        {
            field: 'status',
            headerName: 'Approve/Reject',
            width: 150,

        },
        {
            field: 'batchId',
            headerName: 'Planning Number',
            width: 150,

        },
        {
            field: 'comments',
            headerName: 'Remarks',
            width: 250,

        },
        {
            field: 'attachment',
            headerName: 'Attachment',
            width: 150,

            renderCell: (params) => {
                return (
                    <Tooltip title="View">
                        <IconButton color="primary" onClick={(e) => onViewBtnClick(e, params)} disabled={!params?.row.blobFile || params?.row?.blobFile === ''}>
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                )
            }
        },
    ]

    function EditInputCell(props) {
        const { error, id, value: valueProp, field } = props;
        const [value, setValue] = useState(valueProp);
        const apiRef = useGridApiContext();

        const handleChange = (event) => {
            const newValue = event.target.value;
            apiRef.current.setEditCellValue({ id, field, value: newValue });
            setValue(newValue);
        };

        useEffect(() => {
            setValue(valueProp);
        }, [valueProp]);

        return (
            <StyledTooltip open={!!error} title={error}>
                <GridEditInputCell {...props} value={value} onChange={handleChange} />
            </StyledTooltip>
        );
    }

    function renderEdit(params) {
        return <EditInputCell {...params} />;
    }

    const growerSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'Grower',
            width: 150,
        },
        {
            field: 'allocatedQty',
            headerName: 'Qty(in MT)',
            width: 150,
            type: 'number',
            editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            cellClassName: (params) => {
                if (params.value == null) {
                    return '';
                }
                return clsx('super-app', {
                    confirmationStatusPending: params.value === 'Pending',
                    confirmationStatusConfirmed: params.value === 'Confirmed',
                    confirmationStatusRejected: params.value === 'Rejected'
                });
            }
        },
        {
            field: 'growerLandId',
            headerName: 'Land ID',
            width: 300,
        }
    ]
    const hitSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'HIT',
            width: 150,

        },
        {
            field: 'allocatedQty',
            headerName: 'Qty(in MT)',
            width: 150,
            type: 'number',
            editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            cellClassName: (params) => {
                if (params.value == null) {
                    return '';
                }
                return clsx('super-app', {
                    confirmationStatusPending: params.value === 'Pending',
                    confirmationStatusConfirmed: params.value === 'Confirmed',
                    confirmationStatusRejected: params.value === 'Rejected'
                });
            }
        },
    ]
    const lleSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'LLE',
            width: 150
        },
        {
            field: 'allocatedQty',
            headerName: 'Qty(in MT)',
            headerClassName: 'super-app-theme--header',
            width: 150,
            type: 'number',
            editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            cellClassName: (params) => {
                if (params.value == null) {
                    return '';
                }
                return clsx('super-app', {
                    confirmationStatusPending: params.value === 'Pending',
                    confirmationStatusConfirmed: params.value === 'Confirmed',
                    confirmationStatusRejected: params.value === 'Rejected'
                });
            }
        },
    ]
    const transporterSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'Transporter',
            width: 150
        },
        {
            field: 'allocatedQty',
            headerName: 'Qty(in MT)',
            width: 150,
            type: 'number',
            editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            cellClassName: (params) => {
                if (params.value == null) {
                    return '';
                }
                return clsx('super-app', {
                    confirmationStatusPending: params.value === 'Pending',
                    confirmationStatusConfirmed: params.value === 'Confirmed',
                    confirmationStatusRejected: params.value === 'Rejected'
                });
            }
        },
    ]
    const isSubMappingColdef = [
        {
            field: 'stakeholderUrn',
            headerName: 'IS',
            width: 150
        },
        {
            field: 'allocatedQty',
            headerName: 'Qty(in MT)',
            width: 150,
            type: 'number',
            editable: (userLoggedIn === DEMAND_ROLES.DemandPlanner),
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            cellClassName: (params) => {
                if (params.value == null) {
                    return '';
                }
                return clsx('super-app', {
                    confirmationStatusPending: params.value === 'Pending',
                    confirmationStatusConfirmed: params.value === 'Confirmed',
                    confirmationStatusRejected: params.value === 'Rejected'
                });
            }
        },
    ]

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const onClickProceed = async () => {
        if (selectedFile) await uploadDocumentApi(selectedFile, 'Release');
        else allocationApiCall('Release', null);
        setOpenValidationDialog(false);
    };
    const handleDialogClose = () => {
        setOpenValidationDialog(false);
    }
    const handleCommentChanges = (e) => {
        // e.preventDefault();
        setComments(VALIDATION.noSpecialCharacterValidation(e.target.value))
    }

    const clearSelectedFileBtn = () => {
        setSelectedFile(null)
        setSelectedFileName('')
    }

    const onConfirmSendBack = () => {
        handleSendBackDialogClose();
        allocationApiCall(actionType, null);
    }

    const onClickEdit = async (event, type) => {
        event.preventDefault();
        if (type === "Release") setOpenValidationDialog(IsAllValuesNotConfirmed)
        else {
            if (selectedFile) await uploadDocumentApi(selectedFile, type);
            else handleSendBackDialogOpen(); setActionType(type);
        }
    };

    const allocationApiCall = (type, blobResponse) => {
        const data = {
            "blobFile": blobResponse,
            "batchId": selectedPlanningNumber?.label,
            "workflowInitiatorID": uuid,
            "workflowAction": type,
            "comments": comments,
            "financialYear": selectedFinancialYear,
            "month": planningMonth
        }

        allocateDemandWorkflowApi(data);
    }
    const handleClose = () => {
        setOpen(false);
    };


    const QuickSearchToolbar = () => {
        return (
            <>
                <Box
                    sx={{ p: 0.5, pb: 0, float: 'right' }}>
                    <GridToolbarQuickFilter />
                </Box>
            </>
        );
    }
    const CustomToolbarStakeholder = (props) => {
        return (
            <>
                <Box
                    sx={{ p: 0.5, pb: 0, float: 'right' }}>
                    <GridToolbarQuickFilter />
                </Box>
                <Box
                    sx={{ p: 1.5, float: 'left' }}>
                    <Typography variant="subtitle2">Total Qty Allocated: {monthlyDashboardData && monthlyDashboardData[props?.totalQtyField]}</Typography>
                </Box>
            </>
        );
    }
    const CustomToolbar = () => {
        let sheetList = ['All Route Allocation', 'Grower Allocation', 'HIT Allocation', 'LLE Allocation', 'Transporter Allocation']
        let tempDataArray = [monthlyAllocationData, growerMappingList, hitMappingList, lleMappingList, transporterMappingList]
        const writeToMultipleSheets = (dataArray) => {
            let workbook = XLSX.utils.book_new();
            dataArray.forEach((data, index) => {
                let sheetName = sheetList[index];
                let worksheet = XLSX.utils.json_to_sheet(data);
                XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            });
            XLSX.writeFile(workbook, 'multiple_sheets.xlsx');
        };

        return (
            <>
                <Box
                    sx={{ p: 0.5, pb: 0, float: 'right' }}>
                    <GridToolbarQuickFilter />
                </Box>
                <Box
                    sx={{ p: 0.5, pb: 0, float: 'left' }}>
                    <Button startIcon={<DownloadIcon />} onClick={() => writeToMultipleSheets(tempDataArray)}>Download</Button>

                </Box>
            </>

        );
    }
    const customGridFunction = (rowData, colDef, allocationType, totalQtyField) => {
        return (
            <Card style={{ height: 500 }}>
                <CardContent>
                    <Typography variant='subtitle1' style={{ marginBottom: 5 }}>{allocationType}</Typography>
                    <Box sx={{
                        '& .super-app-theme--header': {
                            wordWrap: 'break-word',
                            wordBreak: 'break-all',
                            whiteSpace: 'initial',
                        },
                        '& .MuiDataGrid-cell--editable': {
                            bgcolor: (theme) =>
                                theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                        },
                        '& .super-app.confirmationStatusPending': {
                            backgroundColor: '#FFFF8F',
                            color: '#1a3e72',
                            fontWeight: '600',
                        },
                        '& .super-app.confirmationStatusRejected': {
                            backgroundColor: '#F88379',
                            color: '#1a3e72',
                            fontWeight: '600',
                        },
                        '& .super-app.confirmationStatusConfirmed': {
                            backgroundColor: '#ECFFDC',
                            color: 'green',
                            fontWeight: '600',
                        },
                        '& .Mui-error': {
                            backgroundColor: `rgb(126,10,15,0.1)`,
                            color: (theme) => theme.palette.error.main,
                        },
                    }}>

                        <DataGrid
                            {...allocationType}
                            getRowHeight={() => 'auto'}
                            autoHeight
                            rows={rowData}
                            columns={colDef}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            processRowUpdate={(newRow, oldRow) => processRowUpdate(newRow, oldRow, rowData)}
                            pagination
                            pageSize={pageSize}
                            onPageSizeChange={(newPage) => setPageSize(newPage)}
                            components={{ Toolbar: (props) => <CustomToolbarStakeholder {...props} totalQtyField={totalQtyField} /> }}
                            componentsProps={{toolbar: {rows: rowData, columns: colDef, fileName: "Export_to_Excel.xlsx", isExportToExcel: false }}}
                        />

                    </Box>
                </CardContent>
            </Card>
        )
    }
    const processRowUpdate = (newRow, oldRow, rowData) => {
        const updatedRow = { ...newRow }
        rowData.forEach((item) => {
            if (item.id === newRow.id) {
                item.allocatedQty = newRow.allocatedQty
            }
        })
        const modifiedData = {
            "stakeholderURN": updatedRow.stakeholderUrn,
            "qty": updatedRow.allocatedQty,
            "growerLandId": updatedRow.growerLandId,
            "stakeholderType": updatedRow.stakeholderType
        }
        const tempArr = [...arr]
        if (tempArr.length !== 0) {
            let objExist = tempArr?.filter(obj => obj.stakeholderURN === modifiedData.stakeholderURN);
            if (objExist?.length > 0) {
                objExist[0].qty = modifiedData.qty
            } else tempArr.push(modifiedData)
        } else tempArr.push(modifiedData)
        setArr(tempArr)
        return updatedRow
    };
    const onViewBtnClick = (e, params) => {
        downloadDocument(params?.row?.blobFile)
    }

    const handlePlanningMonthChnage = (event) => {
        setPlanningMonth(event.target.value);
        getWorkflowListApi(selectedFinancialYear, event.target.value);
    };
    const getSelectedValue = (dataToBePassed) => {
        setSelectedFinancialYear(dataToBePassed);
        setIsNotifyStakeholderDisabled(false);
        setIsMonthlyAllocationDisabled(false);
        getWorkflowListApi(dataToBePassed, planningMonth);
        getUserRolenNameApi();
    }

    const onConfirmCalculateMonthlyAllocation = () => {
        handleCalculateMonthlyAllocationDialogClose();
        calculateMonthlyAllocationApi(selectedFinancialYear, planningMonth);
    }

    const onHandleCalculateMonthlyAllocation = (e) => {
        e.preventDefault();
        if (!selectedFinancialYear || selectedFinancialYear === 'select') {
            setSelectedFinancialYearErr('Please select financial year')
        } else handleCalculateMonthlyAllocationDialogOpen();

    }
    const handlePlanningNumberChange = (e, value) => {
        setSelectedPlanningNumber(value);
        getMonthlyAllocationApi(selectedFinancialYear, planningMonth, value.label);
        getMonthlyStakeholderAllocationApi(selectedFinancialYear, planningMonth, value.label)
        getPaymentDetailsApi(selectedFinancialYear, planningMonth, value.label)
        getMonthlyAllocationDashboardApi(selectedFinancialYear, planningMonth, value.label)
    }
    const onUploadDocumentClick = (e) => {
        if (demandAllowedFileTypes?.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            toast.error("The file size should be less than 5MB")
        }
        else if (e.target.files[0].name.split('.').length > 2) {
            toast.error("Double extension file detected")
            return;
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            toast.error(FILE_NAME_VALIDATION_ERROR);
        }
        else {
            const files = e.target.files[0]
            const fileName = files.name.slice(0, 25)
            setSelectedFile(files);
            setSelectedFileName(fileName)
        }
    }

    const onConfirmGeneratePo = () => {
        handleGeneratePoDialogClose();
        generatePOAPi();
    }

    const generatePoDetailsValidation = () => {
        let data = approvalHistoryList?.filter((item) => item.batchId === selectedPlanningNumber?.label && item.status === 'Approved')
        getPaymentDetailsApi(selectedFinancialYear, planningMonth, selectedPlanningNumber?.label);
        let validatedData = data.map((item) => { return processingInchargeUsers.includes(item.owner) })
        if (validatedData.includes(true)) {
            if (isPaymentMethodNull.includes(true)) {
                toast.info('Please add payment details before generating PO');
                handleTabChange(null, "3")
            } else {
                handleGeneratePoDialogOpen();
            }
        } else toast.info('Selected allocation is not approved');


    }

    // -----------------API Calls-------------------

    const getPlanningNumberApi = async (year, month, workflowData) => {
        loaderService.showLoader();
        setPlanningNumberList([])
        await apiClient.post(GET_PLANNING_NUMBER,
            {
                "financialYear": year,
                "month": month,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response.data?.planningNumberLst
                if (apiData?.length === 0) setIsSendReleaseDisabled(true)
                else setIsSendReleaseDisabled(false);
                if (userLoggedIn === DEMAND_ROLES.DemandPlanner) {
                    const listOfOptions = apiData?.map((o1) => {
                        return { 'label': o1.planningNumber }
                    })
                    setPlanningNumberList(listOfOptions)
                    const options = apiData?.filter(item => item.isLatest === 1).map((o1) => {
                        return { 'label': o1.planningNumber }
                    })
                    setSelectedPlanningNumber(options[0]);
                    getMonthlyAllocationApi(year, month, options[0]?.label);
                    getMonthlyStakeholderAllocationApi(year, month, options[0]?.label);
                    getPaymentDetailsApi(year, month, options[0]?.label);
                    getMonthlyAllocationDashboardApi(year, month, options[0]?.label);
                } else {
                    const uniqueData = new Set(workflowData?.map((o1) => { return o1.batchId }))
                    const data = [...uniqueData].map((item) => { return { 'label': item } })
                    let options = data.filter((ele, ind) => ind === data.findIndex(elem => elem.label === ele.label))
                    setPlanningNumberList(data)
                    setSelectedPlanningNumber(options[0]);
                    getMonthlyAllocationApi(year, month, options[0]?.label);
                    getMonthlyStakeholderAllocationApi(year, month, options[0]?.label);
                    getPaymentDetailsApi(year, month, options[0]?.label);
                    getMonthlyAllocationDashboardApi(year, month, options[0]?.label);
                }
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getMonthlyAllocationApi = async (year, month, planningNumber) => {
        loaderService.showLoader();
        await apiClient.post(GET_MONTHLY_ALLOCATION,
            {
                "financialYear": year,
                "month": month,
                "planningNumber": planningNumber
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let data = response.data?.demandStakeholderMappingsLst ? response.data?.demandStakeholderMappingsLst : []
                setMonthlyAllocationData(data);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    const getMonthlyStakeholderAllocationApi = async (year, month, planningNumber) => {
        loaderService.showLoader();
        let tempGrowerData = [];
        let tempLleData = [];
        let tempTransData = [];
        let tempHitData = [];
        let tempIsData = [];

        setLleMappingList([]);
        setGrowerMappingList([]);
        setTransporterMappingList([]);
        setHitMappingList([]);
        setIsMappingList([]);

        await apiClient.post(GET_MONTHLY_STAKEHOLDER_ALLOCATION,
            {
                "financialYear": year,
                "month": month,
                "planningNumber": planningNumber
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response.data.stakeholderAllocationLst;
                if (apiData?.length) {
                    apiData?.map((item) => {
                        if (item.stakeholderType === 'LLE') {
                            tempLleData.push(item)
                            setLleMappingList(tempLleData);
                        } else if (item.stakeholderType === 'Transporter') {
                            tempTransData.push(item)
                            setTransporterMappingList(tempTransData);
                        } else if (item.stakeholderType === 'Grower') {
                            tempGrowerData.push(item)
                            setGrowerMappingList(tempGrowerData);
                        } else if (item.stakeholderType === 'HIT') {
                            tempHitData.push(item)
                            setHitMappingList(tempHitData);
                        } else if (item.stakeholderType === 'IS') {
                            tempIsData.push(item)
                            setIsMappingList(tempIsData);
                        }
                    })
                    let isStatusConfirmed = apiData.some((item) => item.status !== 'Confirmed')
                    if (isStatusConfirmed) setIsAllValuesNotConfirmed(true)
                    else setIsAllValuesNotConfirmed(false)

                } else {
                    setLleMappingList([]);
                    setGrowerMappingList([]);
                    setTransporterMappingList([]);
                    setHitMappingList([]);
                    setIsMappingList([])
                }
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onConfirmNotifyStakeholder = () => {
        handleNotifyStakeholderDialogClose();
        loaderService.showLoader();
        apiClient.post(NOTIFY_STAKEHOLDER,
            {
                "financialYear": selectedFinancialYear,
                "month": planningMonth,
                "planningNumber": selectedPlanningNumber?.label
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                toast.success(response.data.message);
                getMonthlyStakeholderAllocationApi(selectedFinancialYear, planningMonth, selectedPlanningNumber?.label)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const notifyStakeholderApi = async () => {
        handleNotifyStakeholderDialogOpen();
    }
    const calculateMonthlyAllocationApi = async (year, month) => {
        loaderService.showLoader();
        await apiClient.post(CALCULATE_MONTHLY_ALLOCATION + `?userId=${uuid}`,
            {
                "planningMonthDTO": {
                    "financialYear": year,
                    "month": month,
                },
                "stakeholderAllocations": arr
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (response.data.isSuccess === false) toast.error(response.data.message)
                else if (response.data.isSuccess === true) toast.success(response.data.message)
                getPlanningNumberApi(selectedFinancialYear, planningMonth, 'isCalculated');
                loaderService.hideLoader();
            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    const getWorkflowListApi = async (year, month) => {
        loaderService.showLoader();
        await apiClient.post(GET_WORKFLOW_LIST,
            {
                "financialYear": year,
                "month": month,
                "userId": uuid
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response.data?.demandWorkFlowStepDetails ? response.data?.demandWorkFlowStepDetails : [];
                setApprovalHistoryList(apiData);
                getPlanningNumberApi(year, month, apiData);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    const uploadDocumentApi = async (selectedFile, type) => {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", `${selectedPlanningNumber.label}` + '.xls');
        formData.append("containerName", "demandworkflow");
        await apiClient.post(UPLOAD_EXCEL_DCUMENT,
            formData,
            {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    AuthKey: authKey,
                },
            }
        )
            .then((response) => {
                setBlobResponse(response.data?.blobResponse?.blobFileName);
                setSelectedFile('')
                allocationApiCall(type, response.data?.blobResponse?.blobFileName)
                toast.success(response.data.message)
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
            });
    }
    const allocateDemandWorkflowApi = async (data) => {
        loaderService.showLoader();
        await apiClient.post(ALLOCATE_DEMAND_WORKFLOW,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                toast.success(response.data.message);
                getWorkflowListApi(selectedFinancialYear, planningMonth)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    const downloadDocument = (blobFileName) => {
        loaderService.showLoader()
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": blobFileName,
                    "containerName": "demandworkflow",
                    "file": ""
                })
            })
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${blobFileName}.${'xlsx'}`;
                link.click()
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
            });
    }
    const getPaymentDetailsApi = async (year, month, planningNumber) => {
        loaderService.showLoader();
        await apiClient.post(GET_PAYMENT_DETAILS,
            {
                "financialYear": year,
                "month": month,
                "planningNumber": planningNumber,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setPaymentListData(response?.data?.paymentLst);
                let isValueNull = response?.data?.paymentLst?.map((item) => {
                    if (item?.paymentMethod === null) {
                        return true
                    }
                    else return false
                })
                setIsPaymentMethodNull(isValueNull);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    const getMonthlyAllocationDashboardApi = (year, month, planningNumber) => {
        loaderService.showLoader();
        apiClient.post(GET_MONTHLY_ALLOCATION_DASHBOARD,
            {
                "financialYear": year,
                "month": month,
                "planningNumber": planningNumber,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setMonthlyDashboardData(response?.data?.dashboardmodel)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    const generatePOAPi = async () => {
        loaderService.showLoader();
        await apiClient.post(GENERATE_PO,
            {
                "financialYear": selectedFinancialYear,
                "month": planningMonth,
                "planningNumber": selectedPlanningNumber?.label
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (response.data.isSuccess === true) toast.success(response.data.message)
                else if (response.data.isSuccess === false) toast.error(response.data.message)
                generateMonthlyAllocationAPi();
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });

    }
    const generateMonthlyAllocationAPi = async () => {
        loaderService.showLoader();
        await apiClient.post(GENERATE_MONTHLY_ALLOCATION,
            {
                "financialYear": selectedFinancialYear,
                "month": planningMonth,
                "planningNumber": selectedPlanningNumber?.label
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (response.data.isSuccess === true) toast.success(response.data.message)
                else if (response.data.isSuccess === false) toast.error(response.data.message)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });

    }
    const getUserRolenNameApi = async (id) => {
        loaderService.showLoader();
        await apiClient.post(GET_USER_BY_ROLES,
            {
                "roleName": DEMAND_ROLES.ProcurementLead,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response?.data?.users ? response?.data?.users : []
                let dataListArr = apiData.map((item) => item.id)
                setProcessingInchargeUsers(dataListArr)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    return (
        <Grid container>
            <Grid item xs={12} lg={12}>
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM04</p>}
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={6} lg={3}>
                                <FinancialYearDropdown selectedValue={getSelectedValue} />
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <FormControl sx={{ width: '100%' }} size="small">
                                    <InputLabel id="demo-simple-select-helper-label">Planning Month</InputLabel>
                                    <MaterialSelect
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value={planningMonth}
                                        label="Planning Month"
                                        onChange={handlePlanningMonthChnage}
                                    >
                                        {monthArray.map((item) =>
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        )}
                                    </MaterialSelect>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={planningNumberList ? planningNumberList : []}
                                    sx={{ width: '100%' }}
                                    value={planningNumberList && planningNumberList?.length !== 0 ? selectedPlanningNumber : ''}
                                    size='small'
                                    onChange={(event, newInputValue) => handlePlanningNumberChange(event, newInputValue)}
                                    renderInput={(params) => <TextField {...params} label="Planning Number" />}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                            <Tab label="Monthly Allocation" value="1" />
                            <Tab label="Dashboard" value="2" />
                            {userLoggedIn === DEMAND_ROLES.ProcurementLead && <Tab label="Payment Details" value="3" />}
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={12}>
                                <Card>
                                    <CardContent>
                                        {userLoggedIn === DEMAND_ROLES.DemandPlanner &&
                                            <Stack direction="row" spacing={1} style={{ float: 'right', marginBottom: 10 }}>
                                                <CustomButton
                                                    title="Notify Stakeholder"
                                                    disabled={isNotifyStakeholderDisabled}
                                                    startIcon={<NotificationAlertIcon />}
                                                    onClick={(e) => notifyStakeholderApi(e)}
                                                />
                                                <CustomButton
                                                    disabled={isMonthlyAllocationDisabled}
                                                    onClick={(e) => onHandleCalculateMonthlyAllocation(e)}
                                                    style={{ float: 'right' }}
                                                    startIcon={<CalculateIcon />}
                                                    title="Calculate Monthly Allocation" />
                                            </Stack>
                                        }
                                        <Dialog
                                            open={openValidationDialog}
                                            aria-labelledby="responsive-dialog-title"
                                        >
                                            <DialogTitle id="responsive-dialog-title">
                                                {"All stakeholders haven't Confirmed yet,"}
                                            </DialogTitle>
                                            <DialogContent>
                                                <DialogContentText>
                                                    Are you sure you want to Release the Allocation into workflow?
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => handleDialogClose()}>Cancel</Button>
                                                <Button onClick={() => onClickProceed()}>Confirm</Button>
                                            </DialogActions>
                                        </Dialog>
                                        <Typography variant='subtitle1' style={{ marginBottom: 5, marginTop: 5 }}>All Route Allocation</Typography>
                                        <Box sx={{
                                            height: '300', width: '100%', display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            '& .super-app-theme--header': {
                                                width: 250,
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-all',
                                                whiteSpace: 'initial',
                                            },
                                        }}>
                                            <DataGrid
                                                getRowHeight={() => 'auto'}
                                                autoHeight
                                                columns={columns}
                                                rows={monthlyAllocationData}
                                                experimentalFeatures={{ newEditingApi: true }}
                                                components={{ Toolbar: CustomDataGridToolbar }}
                                                componentsProps={{toolbar: {rows: monthlyAllocationData, columns: columns, fileName: "Monthly_Allocation.xlsx", isExportToExcel: true }}}
                                                pagination
                                                pageSize={pageSize}
                                                onPageSizeChange={(newPage) => setPageSize(newPage)} getRowClassName={(params) =>
                                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                                }
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            {<Grid item xs={12} lg={12}>{customGridFunction(growerMappingList, growerSubMappingColdef, 'Grower Allocation', 'totalQtyGrower')}</Grid>}
                            {<Grid item xs={12} lg={6}>{customGridFunction(hitMappingList, hitSubMappingColdef, 'HIT Allocation', 'totalQtyHit')}</Grid>}
                            {<Grid item xs={12} lg={6}>{customGridFunction(lleMappingList, lleSubMappingColdef, 'LLE Allocation', 'totalQtyLle')}</Grid>}
                            {<Grid item xs={12} lg={6}>{customGridFunction(transporterMappingList, transporterSubMappingColdef, 'Transporter Allocation', 'totalQtyTransporter')}</Grid>}
                            {<Grid item xs={12} lg={6}>{customGridFunction(isMappingList, isSubMappingColdef, 'IS Allocation', 'totalQtyIs')}</Grid>}
                            <Grid item xs={12} lg={12}>
                                <Card>
                                    <CardContent>
                                        <Grid container >
                                            <Grid item xs={12} lg={6}>
                                                {userLoggedIn !== DEMAND_ROLES.ProcurementLead &&
                                                    <TextField
                                                        inputProps={{ style: { height: 30, textTransform: "capitalize" }, maxLength: openTextFieldMaxLength }} sx={{ width: '100%' }}
                                                        id="outlined-basic"
                                                        label="Comments"
                                                        variant="outlined"
                                                        multiline
                                                        // type='number'
                                                        value={comments}
                                                        onChange={(e) => handleCommentChanges(e)}
                                                    />}
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <Stack direction="row" style={{ float: 'right' }} spacing={1}>
                                                    {(userLoggedIn === DEMAND_ROLES.DemandModuleIncharge || userLoggedIn === DEMAND_ROLES.ProcessingIncharge) &&
                                                        <CustomButton
                                                            startIcon={<SendBackIcon />}
                                                            title="Send Back"
                                                            disabled={isSendReleaseDisabled}
                                                            onClick={(e) => onClickEdit(e, 'Send_Back')}
                                                        />
                                                    }
                                                    {userLoggedIn !== DEMAND_ROLES.ProcurementLead &&
                                                        <Stack direction='column' spacing={1}>
                                                            <Stack direction='row' spacing={2}>
                                                                <CustomButton
                                                                    startIcon={<ReleaseIcon />}
                                                                    title="Release"
                                                                    disabled={isSendReleaseDisabled}
                                                                    onClick={(e) => onClickEdit(e, 'Release')}
                                                                />
                                                                <Button variant="contained" component="label" startIcon={<UploadIcon />} disabled={isSendReleaseDisabled}>
                                                                    Upload Document
                                                                    <input onChange={(e) => onUploadDocumentClick(e)} hidden accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.oasis.opendocument.spreadsheet" type="file" />
                                                                </Button>
                                                            </Stack>
                                                            {selectedFile &&
                                                                <Stack direction='row' style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                                    <Typography variant='caption'><b>Selected File : </b> {selectedFileName}</Typography>
                                                                    <IconButton aria-label="delete" size="small" style={{ float: 'right' }} onClick={(e) => clearSelectedFileBtn(e)}>
                                                                        <HighlightOffIcon fontSize='small' style={{ color: 'red' }} />
                                                                    </IconButton>
                                                                </Stack>
                                                            }
                                                        </Stack>
                                                    }
                                                    {userLoggedIn === DEMAND_ROLES.ProcurementLead &&
                                                        <CustomButton
                                                            startIcon={<GenerateIcon fontSize="large" />}
                                                            title="Generate PO"
                                                            disabled={isSendReleaseDisabled}
                                                            onClick={() => generatePoDetailsValidation()}
                                                        />
                                                    }
                                                </Stack>
                                            </Grid>

                                        </Grid>
                                        <Typography variant='subtitle1' style={{ marginBottom: 5, marginTop: 10 }}>Approval History</Typography>
                                        <Box sx={{
                                            '& .super-app-theme--header': {
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-all',
                                                whiteSpace: 'initial',
                                            },
                                            '& .MuiDataGrid-cell--editable': {
                                                bgcolor: (theme) =>
                                                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                            },
                                        }}>
                                            <DataGrid
                                                getRowHeight={() => 'auto'}
                                                autoHeight
                                                columns={approvalHistoryColDef}
                                                rows={approvalHistoryList}
                                                experimentalFeatures={{ newEditingApi: true }}
                                                hideFooterSelectedRowCount
                                                pagination
                                                pageSize={pageSize}
                                                onPageSizeChange={(newPage) => setPageSize(newPage)}
                                                components={{ Toolbar: CustomDataGridToolbar }}
                                                componentsProps={{toolbar: {rows: approvalHistoryList, columns: approvalHistoryColDef, fileName: "Approve_History_List.xlsx", isExportToExcel: true }}}
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value="2">
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={12}>
                                <MonthlyDashboard
                                    data={monthlyDashboardData}
                                    hitStakeholder={hitMappingList?.length}
                                    transporterStakeholders={transporterMappingList?.length}
                                    growerStakeholders={growerMappingList}
                                    lleStakeholders={lleMappingList?.length} />
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value="3">
                        <PaymentDetails
                            open={open}
                            handleClose={handleClose}
                            data={paymentListData}
                            year={selectedFinancialYear}
                            month={planningMonth}
                            planningNumber={selectedPlanningNumber?.label}
                            getPaymentDetailsApi={getPaymentDetailsApi} />
                    </TabPanel>
                </TabContext>
            </Grid>
            <ConfirmationPopover onOpen={notifyStakeholderDialog} onConfirm={onConfirmNotifyStakeholder} onClose={handleNotifyStakeholderDialogClose} action="Notify Stakeholder" />
            <ConfirmationPopover onOpen={calculateMonthlyAllocationDialog} onConfirm={onConfirmCalculateMonthlyAllocation} onClose={handleCalculateMonthlyAllocationDialogClose} action="Calculate Monthly Allocation" />
            {/* <ConfirmationPopover onOpen={releaseDialog} onConfirm={onConfirmRelease} onClose={handleReleaseDialogClose} action="Release" /> */}
            <ConfirmationPopover onOpen={sendBackDialog} onConfirm={onConfirmSendBack} onClose={handleSendBackDialogClose} action="Send Back" />
            <ConfirmationPopover onOpen={generatePoDialog} onConfirm={onConfirmGeneratePo} onClose={handleGeneratePoDialogClose} action="Generate PO" />
        </Grid>
    )
}